module.exports = __webpack_public_path__ + "static/media/arrow_up.fff75023.svg";